import EntityType from '@enums/EntityType';

export default function isProcess(entityType) {
  if (
    entityType === EntityType.L1_PROCESS ||
    entityType === EntityType.PROCESS
  ) {
    return true;
  }
}
